import React from 'react';
import styled from 'styled-components';
import {InnerLayout} from '../styles/Layouts';
import Title from '../Components/Title';
import SmallTitle from '../Components/SmallTitle';
import BusinessCenterIcon from '@material-ui/icons/BusinessCenter';
import SchoolIcon from '@material-ui/icons/School';
import ResumeItem from '../Components/ResumeItem';

function Resume() {
    const briefcase = <BusinessCenterIcon />
    const school = <SchoolIcon />
    return (
        <ResumeStyled>
            <Title title={'Resume'} span={'resume'} />
            <InnerLayout>
                <div className="small-title">
                    <SmallTitle icon={briefcase} title={'Working Experience'} />
                </div>
                <div className="resume-content">
                    <ResumeItem 
                        year={'(October 2020 – December 2020)'} 
                        title={'Information Technology Internship'}
                        subTitle={'Janata Bank Limited '}
                        text={`A three months professional training program funded by ICT-Department-System of Janata Bank Limited.
                        
                        In This Project My duty was :
                        
                        • Maintain existing code and functionality once it is assimilated into the ongoing operations of the Web. 
                        • Working in an Agile development cycle using advanced Scrum methodologies.
                        • An interest in sharing knowledge about new technologies with the team and facilitating the implementation of such technologies across projects.
                        • Development with cross-browser/cross-device compatibility in a graded browser support environment.
                        • Work with senior-level developers/mentors on development projects for the website, both large and small, throughout the various phases of the project life cycle.
                        • Help develop and follow best practices and development standards.
                        • Performs other related duties as assigned.`} 
                    />
                    <ResumeItem 
                        year={'August 2020 – September 2020'} 
                        title={'Industrial Training & Internship'}
                        subTitle={'Dhaka Bank Limited'}
                        text={`A 19 (nineteen) days professional training  program funded by Dhaka Bank Limited.

                        In this program my duty was:
                        
                        •	Assisted in the development of new web pages, monitored and resolved technical support requests, and provided beneficial advice and support to colleagues on any IT related issues.
                        •	Supported the Senior Officer, configured and maintained various hardware and software, and performed regular back-ups.
                        •	Developed automation scripts, managed and updated databases, and worked closely with team.
                        •	Installed Computer systems and executed other duties as required.`}
                    />
                </div>
                <div className="small-title u-small-title-margin">
                    <SmallTitle icon={school} title={'Educational Qualifications'} />
                </div>
                <div className="resume-content ">
                    <ResumeItem 
                        year={'(January 2018 – PRESENT)'} 
                        title={'BSc. in Information and Communication Engineering'}
                        subTitle={'Noakhali Science and Technology University'}
                        text={'Lorem ipsum dolor sit, amet consectetur adipisicing elit. Culpa nihil impedit natus nostrum? Velit accusantium id quos, nihil vel quod.Quas, magni mollitia, aspernatur consequatur accusamus vero eum facere exercitationem velit suscipit ipsam placeat libero. '} 
                    />
                </div>
            </InnerLayout>
        </ResumeStyled>    
    )
}

const ResumeStyled = styled.section`
    .small-title{
        padding-bottom: 3rem;
    }
    .u-small-title-margin{
        margin-top: 4rem;
    }

    .resume-content{
        border-left: 2px solid var(--border-color);
    }
`;
export default Resume
